import { call, put, takeLatest } from "redux-saga/effects";
import {
    fetchOrganization,
    fetchOrganizationStart,
    fetchOrganizationSuccess,
    fetchOrganizationFailure,
    updateOrganization,
    updateOrganizationStart,
    updateOrganizationSuccess,
    updateOrganizationFailure,
} from "../slices/organizationSlice";
import { makeRequest } from "../../utils/api";
import { Organization, UpdateOrganizationRequest } from "../../types/pages/organization";
import { PayloadAction } from "@reduxjs/toolkit";
import { extractErrorMessage } from "../../utils/helpers";
import { toast } from "react-toastify";

function* fetchOrganizationSaga(): Generator<any, void, any> {
    try {
        yield put(fetchOrganizationStart());
        const response: Organization = yield call(makeRequest, "get", "/organizations/");
        yield put(fetchOrganizationSuccess(response));
    } catch (error: any) {
        yield put(fetchOrganizationFailure(extractErrorMessage(error)));
    }
}

function* updateOrganizationSaga(
    action: PayloadAction<UpdateOrganizationRequest>
): Generator<any, void, any> {
    try {
        yield put(updateOrganizationStart());
        const response: Organization = yield call(
            makeRequest,
            "put",
            "/organizations/",
            action.payload
        );
        yield put(updateOrganizationSuccess(response));
        toast.success("Organization settings updated successfully");
    } catch (error: any) {
        yield put(updateOrganizationFailure(extractErrorMessage(error)));
    }
}

export default function* organizationSaga(): Generator<any, void, any> {
    yield takeLatest(fetchOrganization.type, fetchOrganizationSaga);
    yield takeLatest(updateOrganization.type, updateOrganizationSaga);
}


